export default __webpack_public_path__ + "static/media/linux-icon.8e0aa443.svg";